import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { BrowserInfoServiceService } from '../../services/browser-info-service.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-forbidden-browser-modal',
  templateUrl: './forbidden-browser-modal.component.html',
  styleUrls: ['./forbidden-browser-modal.component.scss'],
})
export class ForbiddenBrowserModalComponent implements OnInit {
  isOpen: boolean = false;

  private readonly disabledPages: string[] = [
    '/registration',
    '/identity-check',
    '/agb',
    '/datenschutz',
    '/impressum',
  ];

  constructor(
    private readonly browserInfoService: BrowserInfoServiceService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.checkCurrentRoute();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkCurrentRoute();
      });
  }

  private checkCurrentRoute(): void {
    const capacitorPlatform: string = Capacitor.getPlatform();

    if (capacitorPlatform !== 'web') {
      this.isOpen = false;

      return;
    }

    if (this.browserInfoService.deviceType === 'desktop') {
      this.isOpen = false;

      return;
    }

    const currentUrl = this.router.url;

    const shouldDisableModal = this.disabledPages.some((disabledPage) =>
      currentUrl.startsWith(disabledPage),
    );

    if (shouldDisableModal) {
      this.isOpen = false;

      return;
    }

    this.isOpen = true;
  }

  goToStore(): void {
    this.browserInfoService.goToStore();
  }
}
